"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameManager = void 0;
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var AudioManager_1 = require("./AudioManager");
var AchievementsManager_1 = require("./AchievementsManager");
var BoardScene_1 = require("./scenes/board-scene/BoardScene");
var BoardManager_1 = require("./scenes/board-scene/BoardManager");
var TutorialLayer_1 = require("./scenes/board-scene/layers/TutorialLayer");
var GameManager = /** @class */ (function () {
    function GameManager() {
    }
    GameManager.setViewPort = function () {
        var isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);
        if (isMobile) {
            GameVars_1.GameVars.gameWidth = GameConstants_1.GameConstants.GAME_WIDTH;
            GameVars_1.GameVars.gameHeight = GameConstants_1.GameConstants.GAME_HEIGHT;
            GameVars_1.GameVars.aspectRatio = window.innerHeight / window.innerWidth;
            GameVars_1.GameVars.scaleY = (GameVars_1.GameVars.gameHeight / GameVars_1.GameVars.gameWidth) / GameVars_1.GameVars.aspectRatio;
            GameVars_1.GameVars.isDesktop = false;
        }
        else {
            GameVars_1.GameVars.gameWidth = GameConstants_1.GameConstants.GAME_HEIGHT;
            GameVars_1.GameVars.gameHeight = GameConstants_1.GameConstants.GAME_WIDTH;
            GameVars_1.GameVars.scaleY = 1;
            GameVars_1.GameVars.isDesktop = true;
        }
    };
    GameManager.init = function () {
        if (!GameVars_1.GameVars.currentScene.sys.game.device.os.desktop) {
            GameVars_1.GameVars.currentScene.game.scale.displaySize = GameVars_1.GameVars.currentScene.game.scale.parentSize;
            GameVars_1.GameVars.currentScene.game.scale.refresh();
        }
        var gameKey = "26e5cef5e72d5820a54b9d4ad8002140";
        var secretKey = "c8c2188cfcd290f3546f433bc7290d9403eab911";
        GameVars_1.GameVars.gameAnalytics = require("gameanalytics");
        GameVars_1.GameVars.gameAnalytics.GameAnalytics.initialize(gameKey, secretKey);
        GameVars_1.GameVars.isVideoRewardAvailable = true;
        GameVars_1.GameVars.timeAdShown = 0;
        GameVars_1.GameVars.language = "en" /* ENGLISH */;
        GameManager.generateSeries();
        // LO REFERENTE A LA API DE GAMEDISTRIBUTION
        window["GD_OPTIONS"] = {
            "debug": false,
            "gameId": "994ae6bf58e0404b8aff0af588260852",
            "onEvent": function (event) {
                switch (event.name) {
                    case "SDK_GAME_START":
                        GameVars_1.GameVars.timeAdShown = new Date().getTime();
                        AudioManager_1.AudioManager.unmute();
                        if (GameVars_1.GameVars.rewardValue) {
                            BoardManager_1.BoardManager.onMysteriousItemDetermined(GameVars_1.GameVars.rewardValue);
                            GameManager.loadRewardedAd();
                            GameVars_1.GameVars.rewardValue = 0;
                        }
                        else {
                            if (TutorialLayer_1.TutorialLayer.currentInstance) {
                                TutorialLayer_1.TutorialLayer.currentInstance.onNext();
                            }
                            else if (BoardScene_1.BoardScene.currentInstance.newItemLayer) {
                                BoardManager_1.BoardManager.removeNewItemLayer();
                            }
                            else if (BoardScene_1.BoardScene.currentInstance.levelUpLayer) {
                                BoardManager_1.BoardManager.removeLevelUpLayer();
                            }
                            else {
                                BoardManager_1.BoardManager.hideNewAreaLayer();
                            }
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        AudioManager_1.AudioManager.mute();
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            }
        };
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
        GameManager.readGameData();
    };
    GameManager.loadRewardedAd = function () {
        var w = window;
        if (w.gdsdk !== "undefined" && w.gdsdk.preloadAd !== "undefined") {
            w.gdsdk
                .preloadAd("rewarded")
                .then(function (response) {
                // A rewarded ad can be shown to user when he/she clicked it.
            })
                .catch(function (error) {
                // Any Rewarded ad is not available to user.
            });
        }
    };
    GameManager.readGameData = function () {
        GameManager.getGameStorageData(GameConstants_1.GameConstants.SAVED_GAME_DATA_KEY, function (gameData) {
            if (gameData) {
                GameVars_1.GameVars.gameData = JSON.parse(gameData);
            }
            else {
                GameManager.initGameData();
            }
            if (GameConstants_1.GameConstants.DEVELOPMENT) {
                GameManager.initGameDataWhileDeveloping();
            }
            AchievementsManager_1.AchievementsManager.init();
            if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
                GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode1GameData));
            }
            else {
                GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode2GameData));
            }
            GameManager.startGame();
        });
    };
    GameManager.setCurrentScene = function (scene) {
        GameVars_1.GameVars.currentScene = scene;
    };
    GameManager.onGameAssetsLoaded = function () {
        AudioManager_1.AudioManager.init();
        GameVars_1.GameVars.gameText = GameVars_1.GameVars.currentScene.cache.json.get("game-text");
        GameVars_1.GameVars.cakesNames = GameVars_1.GameVars.currentScene.cache.json.get("cakes-names");
        GameManager.enterBoardScene();
    };
    GameManager.enterBoardScene = function () {
        GameVars_1.GameVars.currentScene.scene.start("BoardScene");
    };
    GameManager.updateLastPlayerAction = function () {
        GameVars_1.GameVars.lastPlayerAction = Date.now();
    };
    GameManager.switchGameMode = function () {
        GameVars_1.GameVars.paused = true;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode2GameData));
            GameVars_1.GameVars.gameData.mode = GameConstants_1.GameConstants.GAME_MODE_2;
        }
        else {
            GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode1GameData));
            GameVars_1.GameVars.gameData.mode = GameConstants_1.GameConstants.GAME_MODE_1;
        }
        GameManager.writeGameData();
        BoardScene_1.BoardScene.currentInstance.showNewGameModeLayer();
    };
    GameManager.resetGame = function () {
        GameManager.initGameData();
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode1GameData));
        }
        else {
            GameVars_1.GameVars.modeGameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.gameData.mode2GameData));
        }
        GameManager.enterBoardScene();
    };
    GameManager.logBoard = function () {
        if (!GameConstants_1.GameConstants.VERBOSE) {
            return;
        }
        console.clear();
        for (var r = 0; r < GameVars_1.GameVars.modeGameData.boardConfiguration.length; r++) {
            var row = GameVars_1.GameVars.modeGameData.boardConfiguration[r];
            var str = "";
            for (var c = 0; c < row.length; c++) {
                if (row[c].n !== -1) {
                    if (row[c].c === 1) {
                        str += "|(" + row[c].n + ")";
                    }
                    else {
                        str += "| " + row[c].n + " ";
                    }
                }
            }
            console.log(str);
        }
    };
    GameManager.writeGameData = function () {
        if (GameVars_1.GameVars.gameData.tutorialPhase) {
            return;
        }
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            GameVars_1.GameVars.gameData.mode1GameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.modeGameData));
        }
        else {
            GameVars_1.GameVars.gameData.mode2GameData = JSON.parse(JSON.stringify(GameVars_1.GameVars.modeGameData));
        }
        GameManager.setGameStorageData(GameConstants_1.GameConstants.SAVED_GAME_DATA_KEY, GameVars_1.GameVars.gameData, function () {
            GameManager.log("game data successfully saved");
        });
    };
    GameManager.log = function (text, error) {
        if (!GameConstants_1.GameConstants.VERBOSE) {
            return;
        }
        if (error) {
            console.error(text + ":", error);
        }
        else {
            console.log(text);
        }
    };
    GameManager.startGame = function () {
        GameVars_1.GameVars.currentScene.scene.start("PreloadScene");
    };
    GameManager.getGameStorageData = function (key, successCb) {
        var gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    };
    GameManager.setGameStorageData = function (key, value, successCb) {
        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    };
    GameManager.generateSeries = function () {
        GameVars_1.GameVars.starsThresholdValues = GameVars_1.GameVars.generateSerie(20, 40, "prev + i * (i * 2 / 3) + 20", null, 35);
        GameVars_1.GameVars.starsThresholdValues = GameVars_1.GameVars.roundValues(GameVars_1.GameVars.starsThresholdValues, 1);
        GameVars_1.GameVars.itemCoinsPerSecond = GameVars_1.GameVars.generateSerie(1, 4, "prev * 2 + pprev * .125", null, 39);
        GameVars_1.GameVars.itemCoinsPerSecond = GameVars_1.GameVars.roundValues(GameVars_1.GameVars.itemCoinsPerSecond, 2);
        GameVars_1.GameVars.shopItemsPrices = GameVars_1.GameVars.generateSerie(10, 1750, "prev * 2 + pprev * .150", null, 39);
        GameVars_1.GameVars.shopItemsPrices = GameVars_1.GameVars.roundValues(GameVars_1.GameVars.shopItemsPrices, 2);
    };
    GameManager.initGameData = function () {
        GameVars_1.GameVars.gameData = {
            muted: false,
            mode: GameConstants_1.GameConstants.GAME_MODE_1,
            isMode2Available: false,
            tutorialPhase: 1,
            mode1GameData: {
                coins: 0,
                stars: 0,
                starsPartialCounter: 0,
                achievementsData: [],
                itemsPurchased: [],
                iMaxItemUncovered: 1,
                boardConfiguration: null,
                lastTimestamp: 0,
                lastWelcomeShown: 0,
                restartCounter: 0,
                canRestart: false,
                timeLastGift: 0
            },
            mode2GameData: {
                coins: 0,
                stars: 0,
                starsPartialCounter: 0,
                achievementsData: [],
                itemsPurchased: [],
                iMaxItemUncovered: 1,
                boardConfiguration: null,
                lastTimestamp: 0,
                lastWelcomeShown: 0,
                restartCounter: 0,
                canRestart: false,
                timeLastGift: 0
            }
        };
        for (var i = 0; i < 7; i++) {
            var achievementData = {
                current: 0,
                claims: [false, false, false]
            };
            GameVars_1.GameVars.gameData.mode1GameData.achievementsData.push(achievementData);
            achievementData = {
                current: 0,
                claims: [false, false, false]
            };
            GameVars_1.GameVars.gameData.mode2GameData.achievementsData.push(achievementData);
        }
        GameVars_1.GameVars.gameData.mode1GameData.achievementsData[1].current = 1;
        GameVars_1.GameVars.gameData.mode2GameData.achievementsData[1].current = 1;
        for (var i = 0; i < GameConstants_1.GameConstants.NUM_ITEMS; i++) {
            var itemsPurchased = {
                isNew: true,
                count: 0
            };
            GameVars_1.GameVars.gameData.mode1GameData.itemsPurchased.push(itemsPurchased);
            itemsPurchased = {
                isNew: true,
                count: 0
            };
            GameVars_1.GameVars.gameData.mode2GameData.itemsPurchased.push(itemsPurchased);
        }
        if (GameVars_1.GameVars.isDesktop) {
            GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
            GameVars_1.GameVars.gameData.mode2GameData.boardConfiguration = GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration.slice();
        }
        else {
            GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
            GameVars_1.GameVars.gameData.mode2GameData.boardConfiguration = GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration.slice();
        }
    };
    GameManager.initGameDataWhileDeveloping = function () {
        if (GameVars_1.GameVars.isDesktop) {
            GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 1, c: 0 }, { n: 2, c: 0 }, { n: 2, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
            GameVars_1.GameVars.gameData.mode2GameData.boardConfiguration = GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration.slice();
        }
        else {
            GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 2, c: 0 }, { n: 2, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 2, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
            GameVars_1.GameVars.gameData.mode2GameData.boardConfiguration = GameVars_1.GameVars.gameData.mode1GameData.boardConfiguration.slice();
        }
        GameVars_1.GameVars.gameData.mode1GameData.coins = 1e8;
        GameVars_1.GameVars.gameData.mode2GameData.coins = 1e8;
        GameVars_1.GameVars.gameData.mode1GameData.iMaxItemUncovered = 2;
        GameVars_1.GameVars.gameData.mode2GameData.iMaxItemUncovered = 2;
        GameVars_1.GameVars.gameData.isMode2Available = true;
    };
    return GameManager;
}());
exports.GameManager = GameManager;
